/*
 * @Author: zhangzhian
 * @Date: 2023-07-10 13:55:27
 * @LastEditors: zhangzhian
 * @LastEditTime: 2023-07-13 19:27:13
 * @FilePath: \dhr_frontend\src\routes\modules\newsManagement.js
 * @Description: 新闻管理路由配置
 */
export default [
  {
    name: 'linsyHeadlines',
    path: '/newsManagement/linsyHeadlines',
    component: () => import('@/views/newsManagement/linsyDynamics/index.vue'),
    meta: {
      title: '林氏头条'
    }
  },
  {
    name: 'addLinsyHeadlinesDetails',
    path: '/newsManagement/linsyHeadlines/add',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '新增林氏头条',
      parentAuth: '/newsManagement/linsyHeadlines'
    },
    props: () => ({
      newsType: '0',
      type: 'add'
    })
  },
  {
    name: 'editLinsyHeadlinesDetails',
    path: '/newsManagement/linsyHeadlines/edit',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '编辑林氏头条',
      parentAuth: '/newsManagement/linsyHeadlines'
    },
    props: () => ({
      newsType: '0',
      type: 'edit'
    })
  },
  {
    name: 'viewLinsyHeadlinesDetails',
    path: '/newsManagement/linsyHeadlines/view',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '查看林氏头条',
      parentAuth: '/newsManagement/linsyHeadlines'
    },
    props: () => ({
      newsType: '0',
      type: 'view'
    })
  },
  {
    name: 'enterpriseDynamics',
    path: '/newsManagement/enterpriseDynamics',
    component: () => import('@/views/newsManagement/linsyDynamics/index.vue'),
    meta: {
      title: '企业动态'
    }
  },
  {
    name: 'addEnterpriseDynamicsDetails',
    path: '/newsManagement/enterpriseDynamics/add',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '新增企业动态',
      parentAuth: '/newsManagement/enterpriseDynamics'
    },
    props: () => ({
      newsType: '1',
      type: 'add'
    })
  },
  {
    name: 'editEnterpriseDynamicsDetails',
    path: '/newsManagement/enterpriseDynamics/edit',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '编辑企业动态',
      parentAuth: '/newsManagement/enterpriseDynamics'
    },
    props: () => ({
      newsType: '1',
      type: 'edit'
    })
  },
  {
    name: 'viewEnterpriseDynamicsDetails',
    path: '/newsManagement/enterpriseDynamics/view',
    component: () => import('@/views/newsManagement/linsyDynamics/edit.vue'),
    meta: {
      title: '查看企业动态',
      parentAuth: '/newsManagement/enterpriseDynamics'
    },
    props: () => ({
      newsType: '1',
      type: 'view'
    })
  }
];
